import React, { useState, useEffect, useCallback } from "react"
import PropTypes from "prop-types"
import NewsStoryCards from "../NewsStoryCard/NewsStoryCard"
import PaginationNews from "../PaginationNews/PaginationNews"
import { findURLValues, strip_html_tags } from "../../helpers/search"
import * as style from "./ListPaginationFilterWrapper-tw-styles"
import FilterListing from "../FilterListing/FilterListing"
import { getSearchResultsNews } from "../../adapters/algolia-adapter"
import {
  CLEAR_ALL,
  UK,
  CAREERS,
  CAREERS_AND_PEOPLE,
} from "../../constants/filterValue.constants"
import { labels } from "../../constants/label.constants"
const ListPaginationFilterWrapper = props => {
  let queryParams = ""

  const { isGeneralNews, variant } = props
  const styles = style[variant] || style.defaultStyle
  const [newsList, setNewsList] = useState({})
  //const PAGE_VALUE = 10
  const [firstindex, setfirstindex] = useState(0)
  const [lastindex, setlastindex] = useState(10)
  const [selectedCategory, setSelectedCategory] = useState("")
  const [toggle, setToggle] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [searchResult, setSearchResult] = useState({})
  const [onload, setOnLoad] = useState(true)
  const { hits = [], nbHits, nbPages, hitsPerPage, page } = searchResult
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  let ftag = ""
  if (isGeneralNews) {
    ftag = ""
  } else {
    ftag = UK
  }
  const onPageChange = pageNumber => {
    if (typeof window != "undefined") {
      const url = new URL(window.location);
      const params = new URLSearchParams(url.search);
      const ftag = isGeneralNews ? params.get('ftag') || "" : UK// Default to UK if ftag is not present     
      const fop = params.get('fop') || ''; // Default to empty string if fop is not present
      queryParams = `?filter=${selectedCategory}&ftag=${ftag}&fop=${fop}&page=${pageNumber}`;
      const newURL = url.origin + url.pathname + queryParams;
      history.pushState({}, "", newURL);
      location.reload();
    }
    changePageIndex(pageNumber, hitsPerPage);
  };
  
  const changePageIndex = (pageNo, pageValue) => {
    setCurrentPage(parseInt(pageNo))
    setfirstindex(pageNo * pageValue - pageValue)
    setlastindex(pageNo * pageValue)
  }
  const fetchNews = category => {
    if (typeof window !== "undefined") {
      const params = window.location.search
      const pageNoMatch = params?.match(/page=([^&#]*)/)
      let pageNumber = 0
      if (pageNoMatch) {
        pageNumber = pageNoMatch[1] - 1
      }

      const obj = {
        pageType: "News Details Page",
        filters: {},
        pageNo: pageNumber,
        search: "",
      }
      let filterOBJ = {}
      if (isGeneralNews) {
        if (category) {
          if (category.toLowerCase() === CAREERS.toLowerCase()) {
            filterOBJ = [CAREERS_AND_PEOPLE]
          } else {
            const categroyArr = category.split("|").map(ele => ele.trim())
            filterOBJ = [...categroyArr]
          }
        } else {
          filterOBJ = labels.filterArray
        }
      } else {
        filterOBJ = [UK]
      }
      obj.filters = filterOBJ

      setIsLoading(true)
      // get search results from Algolia
      getSearchResultsNews(obj)
        .then(res => {
          setSearchResult(res)
          setNewsList(res?.hits?.hits)
          setIsLoading(false)
          if (category) {
            setTotalPages(res?.nbPages)
          } else {
            setTotalPages(5)
          }
        })
        .catch(err => {
          setIsLoading(false)
        })
    }
  }

  useEffect(() => {
    ;(async () => {
      // when user refresh or reload the page data will render according to slug value
      const values = await findURLValues()
      setSelectedCategory(values?.cat)
      setCurrentPage(values?.currPage)
      changePageIndex(values?.pageIn, hitsPerPage)
      if (typeof window !== "undefined") {
        const params = window.location.search
        const filterMatch = params?.match(/filter=([^&#]*)/)
        if (filterMatch) {
          await fetchNews(values?.cat)
        } else {
          await fetchNews(selectedCategory)
        }
      }
    })()
  }, [])

  const handleSelectChange = useCallback(
    (category, catid) => () => {
      if (category.toLowerCase() === CLEAR_ALL.toLowerCase()) {
        queryParams = "?page=1"
      } else {
        queryParams = `?filter=${category}&ftag=${ftag}&page=1`
      }

      if (typeof window != "undefined") {
        const url = new URL(window.location)
        const newURL = url?.origin + url?.pathname + queryParams
        history?.pushState({}, "", newURL)
        if (category.toLowerCase() === CLEAR_ALL.toLowerCase()) {
          //if brand is Clear All then reset the category to blank
          setSelectedCategory("")
          setCurrentPage(1)
        } else {
          //select functionality
          if (selectedCategory != category) {
            setSelectedCategory(category)
          }
        }
        setToggle(!toggle)
      }
      location.reload()
    },
    [selectedCategory, setSelectedCategory, currentPage, toggle]
  )
  if (isLoading) {
    return (
      <div className="pt-50 mx-auto md:w-[960px] max-w-full text-left mb-56 px-15 md:px-30 text-48 font-alternate text-textBlack">
        Loading...
      </div>
    )
  }
  return (
    <div>
      <FilterListing
        handleSelectChange={handleSelectChange}
        selectedCategory={selectedCategory}
        toggle={toggle}
        setToggle={setToggle}
        isGeneralNews={isGeneralNews}
      />
      <div className={styles?.newsMainWrapContainer}>
        {hits?.length > 0 &&
          hits?.map((item, index) => {
            const titleLink = [
              {
                title: item?.content?.textContentWrapper[0]?.title,
                label: item?.content?.textContentWrapper[0]?.title,
                url: item?.slug,
                "aria-label": item?.content?.textContentWrapper[0]?.title,
                target: "_self",
                gaEventClass: "event_internal_link",
              },
            ]
            let shortDescription = ''
            if(item?.content?.textContentWrapper[0]?.shortDescription
              ?.shortDescription){
                shortDescription = strip_html_tags(
                  item?.content?.textContentWrapper[0]?.shortDescription
                    ?.shortDescription
                )
              }
            let videoObj = {}
            if (item?.content?.imageTextWarpper[0]?.video) {
              videoObj = {
                ...item?.content?.imageTextWarpper[0]?.video,
                variant: "QUARTER_WIDTH_VIDEO_WRPR",
              }
            }

            return (
              <div className={styles?.newsMainWrap} key={index}>
                <NewsStoryCards
                  date={item?.content?.date}
                  categoryLinksCollection={
                    item?.content?.imageTextWarpper[0]?.categoryLinks
                  }
                  titleLink={titleLink[0]}
                  description={shortDescription}
                  image={item?.content?.imageTextWarpper[0]?.images}
                  video={videoObj}
                  variant="VIDEO_STORY_CARD"
                />
              </div>
            )
          })}
      </div>
      {hits?.length > 0 && (
        <PaginationNews
          currentPage={currentPage}
          totalPages={totalPages}
          pageSize={hitsPerPage}
          onPageChange={onPageChange}
          totalCount={selectedCategory ? nbHits : labels.newsHomeDataCNT}
          hideAtFirst={true}
        />
      )}
    </div>
  )
}

ListPaginationFilterWrapper.propTypes = {
  isGeneralNews: PropTypes.bool,
  variant: PropTypes.string,
}

export default ListPaginationFilterWrapper